// Closed-trigger text for SourceMultiSelect (FIG-409 · UC-233, AC1). Kept out
// of the component file so React fast refresh works (react-refresh lint rule).

export interface SourceMultiSelectOption {
  value: string;
  label: string;
}

/** "All Sources", the one source's name, or "N sources selected". */
export function describeSourceSelection(selected: readonly string[], options: readonly SourceMultiSelectOption[]): string {
  const ticked = options.filter((o) => selected.includes(o.value));
  if (ticked.length === 0) return 'No sources selected';
  if (options.length > 1 && ticked.length === options.length) return 'All Sources';
  if (ticked.length === 1) return ticked[0].label;
  return `${ticked.length} sources selected`;
}
